export enum PeriodType {
  PREDEFINED = 'predefined',
  SCHEDULED = 'scheduled',
  PERIOD_SELECTOR = 'periodselector',
  CODELOCKS_PERIOD_SELECTOR = 'codelocks_periodselector',
}
